import { ClientToServerEvents } from "backend/src/common/types/socket";
import { useI18n } from "i18n/I18nProvider";
import {
  Box,
  Button,
  Container,
  Form,
  Heading,
  Section,
} from "react-bulma-components";
import { toast } from "react-toastify";
import { getOrCreateSocket } from "socket/socket";

type RoomPageProps = {
  room: string;
};

type AdminAction = Extract<
  keyof ClientToServerEvents,
  "oneStepBack" | "toStageStart" | "toCycleStart"
>;

const actions: AdminAction[] = ["oneStepBack", "toStageStart", "toCycleStart"];

export const RoomPage: React.FC<RoomPageProps> = ({ room }) => {
  const { t } = useI18n();
  return (
    <Section>
      <Container>
        <Box>
          <Heading>{room}</Heading>
          {actions.map((action) => (
            <Form.Field key={action}>
              <Button
                onClick={() => {
                  const socket = getOrCreateSocket();
                  socket.emit(action, room);
                  toast(
                    t("admin.toast.actionSent", {
                      label: t(`admin.action.${action}`),
                    }),
                  );
                }}
              >
                {t(`admin.action.${action}`)}
              </Button>
            </Form.Field>
          ))}
        </Box>
      </Container>
    </Section>
  );
};
